export default __webpack_public_path__ + "static/media/instagram.c635f85d.svg";